export default __webpack_public_path__ + "5788835691319f38cdcd07ae9c0ba6d2.png";